import React from 'react';
import { FaCheck } from 'react-icons/fa';

const WizardProgress = ({ currentStep, totalSteps, onStepClick, color }) => {
  const steps = [
    { number: 1, label: 'Basic Info' },
    { number: 2, label: 'Connection' },
    { number: 3, label: 'Capabilities' },
    { number: 4, label: 'Clients' },
    { number: 5, label: 'Environment' },
    { number: 6, label: 'Setup' },
    { number: 7, label: 'Repository' },
    { number: 8, label: 'Review' },
  ];

  return (
    <div className="mb-8">
      {/* Desktop Progress Bar */}
      <div className="hidden md:flex items-center justify-between">
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <div className="flex flex-col items-center flex-1">
              <button
                type="button"
                onClick={() => onStepClick(step.number)}
                disabled={step.number > currentStep}
                className={`
                  w-12 h-12 rounded-full border-2 flex items-center justify-center
                  font-semibold text-sm transition-all duration-300
                  ${
                    step.number < currentStep
                      ? 'border-green-500 bg-green-500 text-white cursor-pointer hover:bg-green-600'
                      : step.number === currentStep
                      ? 'text-white cursor-default'
                      : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-spooky-bg-medium text-gray-400 dark:text-gray-500 cursor-not-allowed'
                  }
                `}
                style={
                  step.number === currentStep
                    ? { backgroundColor: color, borderColor: color }
                    : {}
                }
              >
                {step.number < currentStep ? <FaCheck /> : step.number}
              </button>
              <span
                className={`
                  mt-2 text-xs font-medium text-center
                  ${
                    step.number === currentStep
                      ? 'text-gray-900 dark:text-spooky-ghost-white'
                      : 'text-gray-500 dark:text-gray-400'
                  }
                `}
              >
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className="flex-1 h-0.5 bg-gray-300 dark:bg-gray-600 mx-2 mb-6">
                <div
                  className="h-full transition-all duration-300"
                  style={{
                    width: step.number < currentStep ? '100%' : '0%',
                    backgroundColor: '#10b981', // green-500
                  }}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Mobile Progress Bar */}
      <div className="md:hidden">
        <div className="flex items-center gap-3 mb-4">
          <div
            className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg"
            style={{ backgroundColor: color }}
          >
            {currentStep}
          </div>
          <div>
            <div className="text-sm text-gray-500 dark:text-gray-400">
              Step {currentStep} of {totalSteps}
            </div>
            <div className="font-semibold text-gray-900 dark:text-spooky-ghost-white">
              {steps[currentStep - 1].label}
            </div>
          </div>
        </div>
        <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
          <div
            className="h-2 rounded-full transition-all duration-300"
            style={{
              width: `${(currentStep / totalSteps) * 100}%`,
              backgroundColor: color,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default WizardProgress;
